import styled from 'styled-components';
export const DropdownContainer = styled.div `
  position: relative;

  padding: 1.8rem 2.2rem;

  border-radius: ${({ theme }) => theme.borderRadius.highM};

  background-color: ${({ theme }) => theme.colors.surface.default};

  ${({ theme }) => theme.media.tabletL `
    padding: 2.4rem 4rem;
  `}
`;
export const TitleWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: ${({ shouldIconShow }) => (shouldIconShow ? 'pointer' : 'unset')};
`;
export const IconWrapper = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;

  min-height: 4rem;
  min-width: 4rem;

  border-radius: ${({ theme }) => theme.borderRadius.highest};

  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};

  transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : '')};
  transition: 0.5s;

  svg {
    height: 2rem;
  }

  ${({ theme }) => theme.media.tabletL `
    min-height: 4.4rem;
    min-width: 4.4rem;

    svg {
      height: 3rem;
    }
  `}
`;
export const ChildrenWrapper = styled.div `
  overflow: hidden;

  max-height: ${({ isOpen, contentHeight }) => {
    if (!contentHeight && !isOpen) {
        return '0';
    }
    else {
        if (isOpen) {
            return contentHeight ? `${contentHeight + 14.7}rem` : 'initial';
        }
        else
            return `0`;
    }
}};
  transition: max-height 0.5s ease-out;
`;
//# sourceMappingURL=styles.js.map